var map = {
	"./beanie-mockup.png": 89521,
	"./beanie-pattern.jpg": 2884,
	"./beanie-pattern.png": 32522,
	"./beanie_adult_blue.jpg": 17166,
	"./beanie_child_pair.jpg": 83837,
	"./blog/buttonhole_gray.jpg": 68454,
	"./blog/buttonhole_gray_2.jpg": 43966,
	"./blog/buttonhole_gray_3.jpg": 34533,
	"./blog/buttonhole_green.jpg": 3304,
	"./blog/buttonhole_green_2.jpg": 82317,
	"./blog/buttonhole_green_3.jpg": 73822,
	"./blog/buttonhole_green_4.jpg": 46246,
	"./blog/buttonhole_pink.jpg": 47706,
	"./blog/buttonhole_pink_2.jpg": 67891,
	"./blog/buttonhole_results-en.jpg": 86308,
	"./blog/buttonhole_results-is.jpg": 24617,
	"./blog/laine-blog-01.jpg": 6756,
	"./blog/laine-blog-02.jpg": 64779,
	"./blog/laine-blog-03.jpg": 51962,
	"./blog/laine-blog-04.jpg": 67281,
	"./blog/laine-blog-05.jpg": 3489,
	"./blog/laine-blog-06.jpg": 42883,
	"./blog/laine-blog-magazine.jpg": 58836,
	"./blog/patterned_mittens_1.jpg": 33666,
	"./blog/patterned_mittens_2.jpg": 10450,
	"./blog/patterned_mittens_3.jpg": 57299,
	"./blog/patterned_mittens_5.jpg": 27848,
	"./blog/patterned_mittens_6.jpg": 3032,
	"./blog/patterned_mittens_7.jpg": 8389,
	"./blog/patterned_mittens_chart.png": 63716,
	"./blog/patterned_mittens_drawn_chart.jpg": 26915,
	"./blog/patterned_mittens_screenshot_en.png": 55039,
	"./blog/patterned_mittens_screenshot_is.png": 53957,
	"./blog/patterned_mittens_yarn.jpg": 42726,
	"./blog/saara_beanie_1.jpg": 91068,
	"./blog/saara_beanie_2.jpg": 33988,
	"./blog/saara_making_of_1.jpg": 49967,
	"./blog/saara_making_of_2.jpg": 83003,
	"./blog/saara_swatch_1.jpg": 10885,
	"./blog/saara_swatch_2.jpg": 8787,
	"./blog/saara_yarns_1.jpg": 53756,
	"./blog/saara_yarns_2.jpg": 67820,
	"./blog/sweater_baby_embroidered.jpg": 13382,
	"./blog/sweater_baby_embroidered_2.jpg": 28605,
	"./blog/sweater_baby_embroidered_3.jpg": 42007,
	"./blog/sweater_baby_embroidered_4.jpg": 64366,
	"./blog/sweater_baby_embroidered_5.jpg": 25401,
	"./blog/sweater_baby_embroidered_6.jpg": 91143,
	"./blog/sweater_baby_embroidered_7.jpg": 28749,
	"./blog/sweater_baby_embroidered_8.jpg": 64989,
	"./blog/sweater_baby_embroidered_chart_body.jpg": 74062,
	"./blog/sweater_baby_embroidered_chart_legend-is.jpg": 54591,
	"./blog/sweater_baby_embroidered_chart_legend.jpg": 7927,
	"./blog/sweater_baby_embroidered_chart_sleeve.jpg": 73208,
	"./blog/sweater_baby_embroidered_motif.jpg": 51401,
	"./blog/sweater_kid_cable_1.jpg": 91641,
	"./blog/sweater_kid_cable_2.jpg": 57328,
	"./blog/sweater_kid_cable_3.jpg": 62992,
	"./blog/sweater_kid_cable_4.jpg": 45726,
	"./blog/sweater_kid_cable_5.jpg": 90674,
	"./blog/sweater_kid_cable_6.jpg": 12267,
	"./blog/sweater_kid_cable_7.jpg": 2658,
	"./blog/sweater_kid_cable_chart.jpg": 8782,
	"./blog/sweater_kid_cable_chart_legend-is.jpg": 47661,
	"./blog/sweater_kid_cable_chart_legend.jpg": 509,
	"./blog/sweater_kid_leftover.jpg": 44474,
	"./blog/sweater_kid_leftover_2.jpg": 98865,
	"./blog/sweater_kid_leftover_3.jpg": 95635,
	"./blog/sweater_kid_leftover_4.jpg": 62354,
	"./blog/sweater_kid_leftover_5.jpg": 1632,
	"./blog/sweater_kid_leftover_6.jpg": 98970,
	"./blog/yarn_leftover.jpg": 89403,
	"./blog/yarn_leftover_swatch.jpg": 41587,
	"./blog/yarn_leftover_swatch_2.jpg": 9210,
	"./blue_L_white_S.png": 98891,
	"./check.svg": 91215,
	"./community-showcase/mittens-agnesknitting.jpg": 54898,
	"./community-showcase/mittens-gloaprjon-2.jpeg": 44201,
	"./community-showcase/mittens-gloaprjon.jpeg": 67026,
	"./community-showcase/socks_baby_prjonadagbok.jpg": 13361,
	"./community-showcase/socks_kid_leonie.jpg": 92205,
	"./community-showcase/sweater-charlomakes.jpeg": 42558,
	"./community-showcase/sweater-lotta.jpg": 7863,
	"./community-showcase/sweaters-abbieknits.jpeg": 9571,
	"./device-screenshots/get-started-devices.png": 26397,
	"./device-screenshots/ipad-en.png": 63410,
	"./device-screenshots/ipad-en.webp": 57816,
	"./device-screenshots/ipad-fi.png": 32717,
	"./device-screenshots/ipad-fi.webp": 1960,
	"./device-screenshots/ipad-is.png": 70799,
	"./device-screenshots/ipad-is.webp": 64386,
	"./device-screenshots/laptop-en.png": 96621,
	"./device-screenshots/laptop-en.webp": 1076,
	"./device-screenshots/laptop-fi.webp": 65101,
	"./device-screenshots/laptop-is.webp": 2001,
	"./device-screenshots/pricing-screens.png": 49649,
	"./ellipse-lav.svg": 46842,
	"./gauge-converter-mockup-2-en.png": 45159,
	"./gauge-converter-mockup-2-fi.png": 74105,
	"./gauge-converter-mockup-2-is.png": 60776,
	"./gauge-converter-mockup-2.png": 47635,
	"./gauge-converter-mockup-en.png": 47407,
	"./gauge-converter-mockup-en.webp": 70576,
	"./gauge-converter-mockup-fi.png": 63113,
	"./gauge-converter-mockup-fi.webp": 78742,
	"./gauge-converter-mockup-is.png": 30197,
	"./gauge-converter-mockup-is.webp": 10648,
	"./gauge-converter-mockup.png": 21751,
	"./gauge-from-swatch-mockup-en.png": 99206,
	"./gauge-from-swatch-mockup-en.webp": 89048,
	"./gauge-from-swatch-mockup-fi.png": 4942,
	"./gauge-from-swatch-mockup-fi.webp": 61349,
	"./gauge-from-swatch-mockup-is.png": 77189,
	"./gauge-from-swatch-mockup-is.webp": 65833,
	"./gauge-from-swatch-mockup.png": 22950,
	"./hero-image.jpg": 18014,
	"./icons/beanie-icon.svg": 54444,
	"./icons/mittens-icon.svg": 31316,
	"./icons/socks-icon.svg": 67087,
	"./icons/sweater-icon.svg": 47822,
	"./image-mittens.jpg": 70154,
	"./image-mittens.png": 41737,
	"./image-sweater.jpg": 63737,
	"./image-sweater.png": 61935,
	"./image-yarn.jpg": 24585,
	"./image-yarn.png": 53489,
	"./knit-calculator-mockup-2-en.png": 68832,
	"./knit-calculator-mockup-2-fi.png": 9547,
	"./knit-calculator-mockup-2-is.png": 97305,
	"./knit-calculator-mockup-2.png": 56648,
	"./knit-calculator-mockup-en.png": 57113,
	"./knit-calculator-mockup-en.webp": 35770,
	"./knit-calculator-mockup-fi.png": 71388,
	"./knit-calculator-mockup-fi.webp": 59430,
	"./knit-calculator-mockup-is.png": 75409,
	"./knit-calculator-mockup-is.webp": 43959,
	"./knit-calculator-mockup.png": 29424,
	"./knittable-lav.svg": 39674,
	"./knittable-white.svg": 63127,
	"./knittable_logo_white.svg": 24400,
	"./knitting_hands.jpg": 47773,
	"./knitting_woman.png": 21627,
	"./line_green.svg": 8355,
	"./line_lav.svg": 86734,
	"./line_red.svg": 86409,
	"./line_yellow.svg": 93172,
	"./measure.jpg": 41548,
	"./measure.png": 1416,
	"./mittens-felted.jpg": 40596,
	"./mittens-felted.png": 4378,
	"./mittens-mockup.png": 14228,
	"./mittens-model.jpg": 68126,
	"./mittens-model.png": 36759,
	"./mittens-pattern.jpg": 93583,
	"./mittens-pattern.png": 18972,
	"./mittens_M.png": 27920,
	"./mittens_adult_felted_pattern.jpg": 16361,
	"./mittens_adult_white.jpg": 89475,
	"./mittens_child_felted_striped.jpg": 69010,
	"./mittens_child_pattern.jpg": 36356,
	"./mittens_pair_felted.jpg": 90886,
	"./mittens_pair_felted_spliced.jpg": 9980,
	"./nanna-founder-knittable.jpg": 38659,
	"./our_patterns_beanie.jpg": 61233,
	"./our_patterns_mittens.jpg": 14807,
	"./our_patterns_raglan_sweater.jpg": 746,
	"./our_patterns_socks_many.jpg": 24145,
	"./pricing/pricing-free-en.png": 47253,
	"./pricing/pricing-free-en.webp": 74704,
	"./pricing/pricing-free-fi.png": 52374,
	"./pricing/pricing-free-fi.webp": 87883,
	"./pricing/pricing-free-is.png": 30355,
	"./pricing/pricing-free-is.webp": 76904,
	"./pricing/pricing-monthly-en.png": 67381,
	"./pricing/pricing-monthly-en.webp": 59684,
	"./pricing/pricing-monthly-fi.png": 52469,
	"./pricing/pricing-monthly-fi.webp": 10031,
	"./pricing/pricing-monthly-is.png": 32459,
	"./pricing/pricing-monthly-is.webp": 49131,
	"./pricing/pricing-yearly-en.png": 3891,
	"./pricing/pricing-yearly-en.webp": 81272,
	"./pricing/pricing-yearly-fi.png": 45914,
	"./pricing/pricing-yearly-fi.webp": 92043,
	"./pricing/pricing-yearly-is.png": 3476,
	"./pricing/pricing-yearly-is.webp": 73061,
	"./screenshot-beanie-2-en.png": 4402,
	"./screenshot-beanie-2-fi.png": 21928,
	"./screenshot-beanie-2-is.png": 1665,
	"./screenshot-beanie-en.png": 61472,
	"./screenshot-beanie-en.webp": 98278,
	"./screenshot-beanie-fi.png": 47447,
	"./screenshot-beanie-fi.webp": 47536,
	"./screenshot-beanie-is.png": 22856,
	"./screenshot-beanie-is.webp": 10647,
	"./screenshot-buttonhole-1-en.png": 67859,
	"./screenshot-buttonhole-1-en.webp": 5615,
	"./screenshot-buttonhole-1-is.png": 82822,
	"./screenshot-buttonhole-1-is.webp": 56567,
	"./screenshot-buttonhole-2-en.png": 65497,
	"./screenshot-buttonhole-2-en.webp": 7764,
	"./screenshot-buttonhole-2-is.png": 85570,
	"./screenshot-buttonhole-2-is.webp": 1470,
	"./screenshot-mittens-2-en.png": 34699,
	"./screenshot-mittens-2-fi.png": 25621,
	"./screenshot-mittens-2-is.png": 82558,
	"./screenshot-mittens-en.png": 76210,
	"./screenshot-mittens-en.webp": 63885,
	"./screenshot-mittens-fi.png": 12902,
	"./screenshot-mittens-fi.webp": 77315,
	"./screenshot-mittens-is.png": 54509,
	"./screenshot-mittens-is.webp": 95628,
	"./screenshot-socks-en.png": 41753,
	"./screenshot-socks-en.webp": 42466,
	"./screenshot-socks-fi.png": 18827,
	"./screenshot-socks-fi.webp": 87593,
	"./screenshot-socks-is.png": 33134,
	"./screenshot-socks-is.webp": 42967,
	"./screenshot-sweater-2-en.png": 5519,
	"./screenshot-sweater-2-fi.png": 5773,
	"./screenshot-sweater-2-is.png": 62547,
	"./screenshot-sweater-en.png": 47887,
	"./screenshot-sweater-en.webp": 6759,
	"./screenshot-sweater-fi.png": 76738,
	"./screenshot-sweater-fi.webp": 18487,
	"./screenshot-sweater-is.png": 67851,
	"./screenshot-sweater-is.webp": 70251,
	"./screenshot_create_user-en.png": 30503,
	"./screenshot_create_user-en.webp": 95926,
	"./screenshot_create_user-fi.png": 88989,
	"./screenshot_create_user-fi.webp": 38585,
	"./screenshot_create_user-is.png": 47236,
	"./screenshot_create_user-is.webp": 25930,
	"./screenshot_create_user.png": 41723,
	"./screenshot_knit_calculator.png": 98867,
	"./screenshot_mittens.png": 86795,
	"./screenshot_socks.png": 18417,
	"./select-size.png": 11695,
	"./select-yarn.png": 28032,
	"./set_baby_baige.jpg": 95535,
	"./set_baby_blue.jpg": 21869,
	"./set_baby_green.jpg": 14876,
	"./set_kid_leonie.jpg": 62397,
	"./socks-mockup.png": 57094,
	"./socks-pattern.jpg": 84138,
	"./socks-pattern.png": 93068,
	"./socks_36-37.png": 86042,
	"./socks_baby_pink.jpg": 61197,
	"./start-knitting.png": 72993,
	"./sweater-mockup.png": 25721,
	"./sweater-pattern.jpg": 76402,
	"./sweater-pattern.png": 47110,
	"./sweater_adult_tailored.jpg": 16820,
	"./sweater_child_embroidered.jpg": 60362,
	"./taeknithrounarsjodur_logo_fitted.png": 68327,
	"./tools/buttonhole-mobile.jpg": 96775,
	"./tools/buttonhole.jpg": 44559,
	"./woman_knitting.jpg": 28607,
	"./woman_knitting_pink.png": 48695,
	"./yarns.png": 47113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;